import React, { useState } from "react";
import { X } from "lucide-react";

interface TopicSelectorProps {
  value: string[];
  onChange: (val: string[]) => void;
}

export const TopicSelector = ({
  value,
  onChange,
}: TopicSelectorProps) => {
  const [input, setInput] = useState("");

  const addTopic = (topic: string) => {
    if (!topic.trim()) return;
    if (!value.includes(topic.trim())) {
      onChange([...value, topic.trim()]);
    }
    setInput("");
  };

  const remove = (topic: string) => {
    onChange(value.filter((t) => t !== topic));
  };

  return (
    <div className="rounded-xl border border-input bg-background px-3 py-2">
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {value.map((topic) => (
            <span
              key={topic}
              className="inline-flex items-center rounded-full bg-primary text-primary-foreground text-xs font-medium px-2.5 py-0.5"
            >
              {topic}
              <button
                type="button"
                onClick={() => remove(topic)}
                className="ml-1 text-primary-foreground/80 hover:text-primary-foreground"
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}

      <input
        className="w-full bg-transparent outline-none text-sm placeholder:text-muted-foreground"
        placeholder="Add topics and press Enter"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            addTopic(input);
          }
        }}
      />
    </div>
  );
};
